// Error
export const REQUEST_ERROR_MESSAGE =
  "요청을 처리할 수 없습니다. 다시 시도해 주세요.";
